export default "__VITE_ASSET__DUY7YKwg__"